const locale = {
    build: {
        errorGeneric: "No pudimos crear tu tienda. Inténtalo de nuevo.",
    },
    gallery: {
        title: "¿Qué vas a construir?",
        subtitle: "Empieza desde una plantilla y ajústala a tu negocio.",
        cardCta: "Usar esta",
        tabAll: "Todas",
        tabStores: "Tiendas",
        tabServices: "Servicios",
        tabPortfolios: "Portafolios",
    },
    form: {
        title: "Crea tu tienda con Inteligencia Artificial",
        description: "Describe el tema de tu tienda y los productos que vendes.",
        exampleText: "Ejemplos",
        placeholder: "Cuéntanos sobre tu tienda ideal",
        buttonCreateStore: "Construir mi tienda",
        placeholderExamples: [
            "Una tienda de joyas minimalistas que cobre con Nequi y Wompi",
            "Una cafetería de especialidad con envíos por Mensajeros Urbanos",
            "Una ferretería que atienda a sus clientes por WhatsApp",
            "Una marca de ropa deportiva con pagos a cuotas por Addi",
            "Una floristería con entregas el mismo día por Rappi",
            "Un estudio de arquitectura que reciba pagos con Bold",
            "Una tienda de mascotas con envíos a todo el país por mipaquete",
        ],
        defaultDescription: "Creame una tienda de joyas de estilo minimalista, colores pasteles y con 4 productos dorados.",
        characters: "caracteres",
        minimumCharacters: "Mínimo 10 caracteres",
    },
    loader: {
        stepOne: "Eligiendo el mejor diseño para tu negocio...",
        stepTwo: "Seleccionando las mejores imágenes para tu catalogo...",
        stepThree: "Estamos creando tu tienda con IA...",
    },
    footer: {
        leftButton: {
            label: "Ver otra opción",
        },
        rightButton: {
            label: "Comenzar",
        }
    },
    errors: {
        timeout: "La creación tardó demasiado, intenta de nuevo",
        generic: "Ocurrió un error, intenta más tarde",
    }
};

export default locale;